import React from "react";

import { 
  HeaderContainer, 
  NavbarContainer, 
  Wrapper, 
  NavbarLink, 
  StyledLink } from "../styled-components/headerstyle"

const HeaderBackButton = () => {

  return (
    <HeaderContainer>
      <NavbarContainer>
        <Wrapper>
        <NavbarLink>
        <StyledLink to="/">
          Back
        </StyledLink>
        </NavbarLink>
        </Wrapper>
      </NavbarContainer>
    </HeaderContainer>
  )
}

export default HeaderBackButton;